var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-flag"},[_c('img',{staticClass:"flag-image",attrs:{"src":_vm.flagImageUrl,"alt":_vm.iso}})])
}
var staticRenderFns = []

export { render, staticRenderFns }